import { useEffect, useMemo } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useGetUserSession } from '@/shared/hooks/api/auth'
import BatchEditPanel from '../components/BatchEditPanel'
import { RADAR_SCOPE_TIER_VIEWER_PATH } from '../utils/routes'
import {
  applyScopeTierUrlFilters,
  parseScopeTierUrlFilters,
  shouldRewriteTypesParam,
} from '../utils/urlFilters'

export default function RadarScopeTierBatchPage() {
  const navigate = useNavigate()
  const [params, setParams] = useSearchParams()
  const { data: session } = useGetUserSession()

  const filters = useMemo(() => parseScopeTierUrlFilters(params), [params])

  useEffect(() => {
    if (session && !session.isArtemAdmin) {
      navigate('/', { replace: true })
    }
  }, [navigate, session])

  useEffect(() => {
    const rawTypes = params.get('types')
    if (!shouldRewriteTypesParam(rawTypes, filters.types)) {
      return
    }
    const next = applyScopeTierUrlFilters(new URLSearchParams(params), filters)
    if (next.toString() !== params.toString()) {
      setParams(next, { replace: true })
    }
  }, [filters, params, setParams])

  if (session && !session.isArtemAdmin) {
    return null
  }

  return (
    <div className='flex h-full min-h-svh flex-col'>
      <BatchEditPanel
        defaultStatus={filters.status}
        defaultTiers={filters.tiers}
        defaultTypes={filters.types}
        defaultIncludeUnassigned={filters.includeUnassigned}
        defaultInForceFilter={filters.inForceFilter}
        defaultIncludeTrashed={filters.includeTrashed}
        onDismiss={() => {
          const nextParams = applyScopeTierUrlFilters(new URLSearchParams(), filters)
          const query = nextParams.toString()
          navigate(query ? `${RADAR_SCOPE_TIER_VIEWER_PATH}?${query}` : RADAR_SCOPE_TIER_VIEWER_PATH)
        }}
      />
    </div>
  )
}
